export default class Carousel {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;
        var buildGallery = document.querySelector(".build__gallery");
        $(document).ready(function() {
            $(".build__gallery-items").slick({
                autoplay: false,
                infinite: true,
                nextArrow: "#build__btn--next",
                prevArrow: "#build__btn--previous",
                rows: 1,
                slidesToShow: 4,
                slidesToScroll: 1
            });
        });
        window.addEventListener("resize", () => {
            if (window.innerWidth > 1669) {
                buildGallery.classList.add("row");
            } else {
                buildGallery.classList.remove("row");
            }
        });
    }
}
